import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { cDiscount } from 'src/types/discounts';
import { packagegroups_returndata } from 'src/types/packagegroup_returndata';
import { packagegroups } from 'src/types/packagegroups';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { packagegrouporder } from 'src/types/packagegrouporder';


@Component({
  selector: 'app-packagegroups',
  templateUrl: './packagegroups.component.html',
  styleUrls: ['./packagegroups.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PackagegroupsComponent implements OnInit {
  ListPackageGroups: packagegroups[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledDiscount: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  Discount: cDiscount;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);
    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("PACKAGEGROUPS", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(packagegroupId)
  {
    this.http.delete(bmxurl + "packagegroup/" + this.VenueID + "/" + packagegroupId).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Package Group successfully disabled'});
        this.router.navigateByUrl("/packagegroup");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Package Group'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "PackageGroupListVenue/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ListPackageGroups = (response as packagegroups_returndata).data;

        if ((response as packagegroups_returndata).messages.length > 0)
        {
          (response as packagegroups_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Package Groups, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Package Groups, error: ' + error.messages});
    });
  }

  editData(EditData)
  {
    let PackageGroupId = EditData;
    this.router.navigateByUrl("/packagegroupedit/" + PackageGroupId);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "packagegroup/" + this.VenueID + "/" + element.classID).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.loadgrid(false);
      } 
      else{
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error disabling Package Groups, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error disabling Package Groups, error: ' + error.messages});
    })
    });
    
  }

  dragEnd(event, product)
  {
    let pgList: packagegrouporder[] = [];

    for(let i = 0; i < this.ListPackageGroups.length; i++)
    {
      let pgOrder: packagegrouporder = {
        packagegroupid: this.ListPackageGroups[i].packagegroupid,
        order: i + 1
      };

      pgList.push(pgOrder);
    }

    this.http.post(bmxurl + "PackageGroupOrder/" + this.VenueID, pgList).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Reordered', detail:'Package Groups successfully reordered'});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Reordered', detail: 'An error occurred reordering Package Groups'});
    })  
  }

  }

